<template>
  <div class="login">
    <div class="pageContent">
      <heading-wrap>
        <span slot="title">Forgot Password</span>
      </heading-wrap>
      <div class="login-container text-center">
        <div v-if="showForgotAlert" class="login-box alert alert-success text-center">
          <i class="fa fa-thumbs-up" aria-hidden="true"></i> A password reset link has been sent to your email address.
        </div>
        <div v-if="showResetAlert" >
          <div class="login-box alert alert-success text-center">
            <i class="fa fa-thumbs-up" aria-hidden="true"></i> Your password has been reset.
          </div>
          <div class="form-group row mb-top-20">
            <a class="" @click.prevent="goLogin" href="javascript:;">Back to Login</a>
          </div>
        </div>
        <div v-if="!hideForgotForm && !isReset" class="login-box text-center">
          <div class="form-group row">
            <field
                id="email"
                :placeholder="'Email address'"
                :type="'email'"
                :error="errors.email"
                v-model="model.email"
            />
          </div>
          <div class="form-group row">
            <Button
                class="col-xs-12"
                :onClick="doForgotPassword"
            >
              Reset password
              <img v-if="isLoading" alt="loading" width="15" src="../assets/loader-green-clear.gif">
            </Button>
          </div>
          <div class="form-group row">
            <a class="" @click.prevent="goLogin" href="javascript:;">Back to Login</a>
          </div>
        </div>
        <div v-if="!hideForgotForm && isReset" class="login-box text-center">
          <div class="form-group row">
            <div class="has-password-toggle">
              <field
                  id="first"
                  :placeholder="'New Password'"
                  :error="errors.first"
                  :type="visible.first ? 'text' : 'password'"
                  v-model="model.first"
              />
              <div class="password-toggle" @click="showHidePassword('first')"><i class="fa fa-eye" aria-hidden="true"></i></div>
            </div>
          </div>
          <div class="form-group row">
            <div class="has-password-toggle">
              <field
                  id="password"
                  :placeholder="'Confirm Password'"
                  :error="errors.second"
                  :type="visible.second ? 'text' : 'password'"
                  v-model="model.second"
              />
              <div class="password-toggle" @click="showHidePassword('second')"><i class="fa fa-eye" aria-hidden="true"></i></div>
            </div>
          </div>
          <div class="form-group row">
            <Button
                class="col-xs-12"
                :onClick="doResetPassword"
            >
              Reset password
              <img v-if="isLoading" alt="loading" width="15" src="../assets/loader-green-clear.gif">
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button/button'
import Field from '@/components/Form/Field/field'
import HeadingWrap from '@/components/HeadingWrap/heading-wrap'
import {notificationMixin} from '@/mixins/notificationMixin'
import {authMixin} from '@/mixins/authMixin'

const NOTIFICATION_DELAY = 8000

export default {
  name: 'forgot-password',
  mixins: [notificationMixin, authMixin],
  components: {
    Button,
    Field,
    HeadingWrap
  },
  data: () => ({
    isReset: false,
    model: {
      email: '',
      first: '',
      second: '',
      remember: false
    },
    showResetAlert: false,
    showForgotAlert: false,
    hideForgotForm: false,
    isLoading: false,
    errors: {
      email: '',
      first: '',
      second: ''
    },
    visible: {
      first: false,
      second: false
    }
  }),
  mounted () {
    this.isReset = this.$route.name === 'PasswordReset'
  },
  methods: {
    showHidePassword (key) {
      this.visible[key] = !this.visible[key]
    },
    doForgotPassword () {
      if (this.isLoading) return false
      if (!this.isValidEmail()) return false
      this.isLoading = true
      this.forgotPassword({ username: this.model.email }).then(() => {
        this.hideForgotForm = true
        this.showForgotAlert = true
      }).catch(error => {
        const notification = this.addNotification('danger', error)
        this.isLoading = false
        setTimeout(() => {
          this.closeLastNotification(notification.id)
        }, NOTIFICATION_DELAY) // Wait 8 seconds to remove the notification
      })
    },
    doResetPassword () {
      if (this.isLoading) return false
      if (!this.isValidPassword('first')) return false
      if (!this.isValidPassword('second')) return false
      this.errors.second = ''
      if (this.model.second !== this.model.first) {
        this.errors.second = 'Passwords do not match'
        return false
      }
      console.log(this.$route)
      this.isLoading = true
      this.resetPassword({ token: this.$route.query.request, first: this.model.first, second: this.model.second }).then(() => {
        this.hideForgotForm = true
        this.showResetAlert = true
      }).catch(error => {
        const notification = this.addNotification('danger', error)
        this.isLoading = false
        setTimeout(() => {
          this.closeLastNotification(notification.id)
        }, NOTIFICATION_DELAY) // Wait 8 seconds to remove the notification
      })
    },
    isValidEmail () {
      if (!(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.model.email))) {
        this.errors.email = 'Please enter a valid email address'
        return false
      }

      this.errors.email = ''
      return true
    },
    isValidPassword (key) {
      if (!(/^(?!\s*$).+/.test(this.model[key]))) {
        this.errors[key] = 'Please enter a valid password'
        return false
      }

      this.errors[key] = ''
      return true
    },
    goLogin () {
      this.$router.push({ name: 'Login' })
    }
  }
}
</script>

<style lang="scss">

.login {
  .login-container{
    padding-top: 50px;
  }

  .login-box {
    max-width: 400px;
    margin: 50px auto 0;

    .help-block {
      text-align: left;
    }
  }

  .has-password-toggle {
    position: relative;
    [type=password], [type=text] {
      padding-right: 50px;
    }

    .password-toggle {
      position: absolute;
      right: 0;
      top: 0;
      padding: 6px 12px;
      font-size: 130%;
      line-height: 1.438;
      opacity: .6;
      cursor: pointer;
      &:hover {
        opacity: 1;
      }
    }
  }

  .mb-top-20 {
    margin-top: 20px;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/forgot-password.vue